import { Select } from "antd";
import { Field, Form, Formik } from "formik";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ButtonLoader from "@/Components/ButtonLoader";
import { SelectDownIcon } from "@/Components/Icons/SelectDownIcon";
import { updateClientContactProfileData } from "@/reducers/clientprofile";
import { validateEmail } from "@/validations/auth/login";

import ProfileAvatar from "./ProfileAvatar";
import FieldErrorMessage from "../../FieldErrorMessage";
import { RequiredSymbol } from "../../RequiredSymbol";

const ClientContactProfile = () => {
  const dispatch = useDispatch();
  const { isContactLoading, contactProfileData, user_title } = useSelector(
    (state) => state.clientProfile,
  );
  const [contactProfileObj, setContactProfileObj] = useState({});
  const { clientUserAllPermissions } = useSelector((state) => state.session);
  const updateContactProfileInfo = () => {
    setContactProfileObj(contactProfileData);
  };
  useEffect(() => {
    if (_.isEmpty(contactProfileData)) return;
    // setProfile_Data(profileData);
    updateContactProfileInfo();
  }, [contactProfileData]);

  /**
   * Updates the profile object with the new value for the specified name.
   */
  const handleChange = (name, value) => {
    setContactProfileObj({
      ...contactProfileObj,
      [name]: value,
    });
  };

  return (
    <div className="ClientContactProfile_Wrapper shadow-[0px_1px_8px_0px_#E7EFFB tour-appcloum-my-profile-update rounded-[10px] bg-white px-5 py-6">
      <div className="flex justify-between">
        <h1 className="pb-6 text-[20px] font-semibold leading-[normal] text-black">
          My Profile
        </h1>
        {isContactLoading ? (
          ""
        ) : (
          <p className="text-[14px] font-medium capitalize text-black">
            Actioned By :{"   "}
            <b>
              {contactProfileObj?.actioned_by || "-"} |
              {moment(
                contactProfileObj?.actioned_at,
                "DD/MM/YYYY HH:mm",
                true,
              ).isValid()
                ? moment(
                    contactProfileObj?.actioned_at,
                    "DD/MM/YYYY HH:mm",
                  ).format("DD/MM/YYYY")
                : "-"}
              |
              {moment(
                contactProfileObj?.actioned_at,
                "DD/MM/YYYY HH:mm",
                true,
              ).isValid()
                ? moment(
                    contactProfileObj?.actioned_at,
                    "DD/MM/YYYY HH:mm",
                  ).format("hh:mm A")
                : "-"}
            </b>
          </p>
        )}
      </div>

      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize={true}
        initialValues={{
          contact_title: contactProfileObj?.contact_title || [],
          contact_forename: contactProfileObj?.contact_forename || "",
          contact_surname: contactProfileObj?.contact_surname || "",
          contact_mobile: contactProfileObj?.contact_mobile || "",
          contact_telno: contactProfileObj?.contact_telno || "",
          contact_email: contactProfileObj?.contact_email || "",
          user_ref_no: contactProfileObj?.user_ref_no || "",
        }}
        validate={(values) => {
          const errors = {};
          if (!values.contact_forename) {
            errors.contact_forename = "First name is required";
          }
          if (!values.contact_surname) {
            errors.contact_surname = "Last name is required";
          }

          if (!values.contact_email) {
            errors.contact_email = "Email is required";
          } else {
            const emailError = validateEmail(values.contact_email);
            if (emailError) {
              errors.contact_email = emailError;
            }
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          dispatch(
            updateClientContactProfileData({
              values,
              setSubmitting,
              contactProfileObj,
            }),
          );
        }}
      >
        {({
          submitForm,
          isSubmitting,
          errors,
          touched,
          isValid,
          values,
          setFieldValue,
        }) => (
          <Form>
            <div className="grid gap-6">
              <div className="flex flex-wrap gap-[17px]">
                <ProfileAvatar />
                <div className="grid grow grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 lg:gap-6">
                  <div className="TITLE">
                    <label
                      htmlFor="contact_title"
                      className="text-[14px] font-medium leading-[normal] text-black"
                    >
                      Title
                    </label>
                    <div className="flex flex-col">
                      <Select
                        showSearch
                        style={{ width: "100%" }}
                        placeholder="Select title"
                        optionFilterProp="children"
                        className={`ease duration-200focus:border-primary mt-[7px] min-h-[40px] w-full overflow-hidden rounded-lg border border-lightGrey text-[14px] font-medium leading-[normal] text-black transition-all placeholder:text-[14px] placeholder:font-medium ${errors.contact_title && touched.contact_title ? "!border-red-500" : ""}`}
                        name="contact_title"
                        suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
                        onChange={(value) => {
                          setFieldValue("contact_title", value);
                          // handleChange("contact_title", e.target.value);
                        }}
                        value={values.contact_title}
                      >
                        {isContactLoading ? (
                          <Select.Option
                            value=""
                            className="!text-black"
                            disabled
                          >
                            <p>Please wait...</p>
                          </Select.Option>
                        ) : (
                          Object.entries(user_title).map(
                            ([key, value], index) => {
                              return (
                                <Select.Option value={key} key={index}>
                                  {value}
                                </Select.Option>
                              );
                            },
                          )
                        )}
                      </Select>
                      <FieldErrorMessage name="title" />
                    </div>
                  </div>

                  <div className="FIRST_NAME">
                    <div className="grid gap-3">
                      <label
                        htmlFor="contact_forename"
                        className="text-[14px] font-medium leading-[normal] text-black"
                      >
                        First name <RequiredSymbol />
                      </label>
                      <Field
                        type="text"
                        className={`h-[40px] w-full rounded-lg border border-lightGrey px-4 text-[14px] font-medium leading-[normal] text-black !outline-none !ring-0 focus:border-primary ${
                          errors.contact_forename ? "!border-red-500" : ""
                        }`}
                        autoComplete="off"
                        name="contact_forename"
                        value={values.contact_forename}
                        placeholder="Enter First name"
                        onChange={(e) => {
                          handleChange("contact_forename", e.target.value);
                        }}
                        // disabled
                      />
                    </div>

                    <FieldErrorMessage name="contact_forename" />
                  </div>
                  <div className="LAST_NAME">
                    <div className="grid gap-3">
                      <label
                        htmlFor="contact_surname"
                        className="text-[14px] font-medium leading-[normal] text-black"
                      >
                        Last name <RequiredSymbol />
                      </label>
                      <Field
                        type="text"
                        className={`h-[40px] w-full rounded-lg border border-lightGrey px-4 text-[14px] font-medium leading-[normal] text-black !outline-none !ring-0 focus:border-primary ${
                          errors.contact_surname ? "!border-red-500" : ""
                        }`}
                        autoComplete="off"
                        name="contact_surname"
                        value={values.contact_surname}
                        placeholder="Enter Last name"
                        onChange={(e) => {
                          handleChange("contact_surname", e.target.value);
                        }}
                        // disabled
                      />
                    </div>

                    <FieldErrorMessage name="contact_surname" />
                  </div>

                  <div className="EMAIL">
                    <div className="grid gap-3">
                      <label
                        htmlFor="contact_email"
                        className="text-[14px] font-medium leading-[normal] text-black"
                      >
                        Email <RequiredSymbol />
                      </label>
                      <Field
                        type="text"
                        className={`h-[40px] w-full rounded-lg border border-lightGrey px-4 text-[14px] font-medium leading-[normal] text-black !outline-none !ring-0 focus:border-primary ${
                          errors.contact_email ? "!border-red-500" : ""
                        }`}
                        autoComplete="off"
                        name="contact_email"
                        value={values.contact_email}
                        placeholder="Enter email"
                        disabled
                      />
                    </div>

                    <FieldErrorMessage name="contact_email" />
                  </div>
                  <div className="PHONENUMBER">
                    <label
                      htmlFor="contact_mobile"
                      className="text-[14px] font-medium leading-[normal] text-black"
                    >
                      Phone Number
                    </label>
                    <Field
                      type="number"
                      className={`mt-[7px] h-[40px] w-full rounded-lg border border-lightGrey px-4 text-[14px] font-medium leading-[normal] text-black !outline-none !ring-0 focus:border-primary ${
                        errors.contact_mobile ? "!border-red-500" : ""
                      }`}
                      autoComplete="off"
                      name="contact_mobile"
                      value={values.contact_mobile}
                      placeholder="Enter Phone Number"
                      onChange={(e) => {
                        handleChange("contact_mobile", e.target.value);
                      }}
                    />
                  </div>
                  <div className="DIAL_NO grid gap-3">
                    <label
                      htmlFor="contact_telno"
                      className="text-[14px] font-medium leading-[normal] text-black"
                    >
                      Direct dial
                    </label>
                    <Field
                      type="number"
                      className={`h-[40px] w-full rounded-lg border border-lightGrey px-4 text-[14px] font-medium leading-[normal] text-black !outline-none !ring-0 focus:border-primary ${
                        errors.contact_telno ? "!border-red-500" : ""
                      }`}
                      autoComplete="off"
                      name="contact_telno"
                      value={values.contact_telno}
                      placeholder="Enter Direct Dial"
                      onChange={(e) => {
                        handleChange("contact_telno", e.target.value);
                      }}
                    />
                  </div>
                  <div className="REFERENCENUMBER grid gap-3">
                    <label
                      htmlFor="user_ref_no"
                      className="text-[14px] font-medium leading-[normal] text-black"
                    >
                      Reference Number
                    </label>
                    <Field
                      type="text"
                      className={`h-[40px] w-full rounded-lg border border-lightGrey px-4 text-[14px] font-medium leading-[normal] text-black !outline-none !ring-0 focus:border-primary ${
                        errors.user_ref_no ? "!border-red-500" : ""
                      }`}
                      autoComplete="off"
                      name="user_ref_no"
                      value={values.user_ref_no}
                      placeholder="Enter Reference Number"
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-end gap-5">
                {!clientUserAllPermissions ||
                clientUserAllPermissions.is_allow_to_edit_profile === 1 ? (
                  <>
                    <button
                      type="button"
                      className={`transition-linear relative w-[120px] rounded-lg border border-primary bg-primary text-[14px] font-medium text-white hover:bg-none hover:text-primary ${isContactLoading ? "cursor-wait" : "cursor-pointer"}`}
                      onClick={submitForm}
                      disabled={isSubmitting || isContactLoading}
                    >
                      {isSubmitting ? <ButtonLoader /> : <span>Update</span>}
                    </button>
                    <button
                      className={`transition-linear h-[40px] w-[120px] rounded-lg border border-primary bg-white text-[14px] font-medium leading-[normal] text-primary hover:bg-primary hover:text-white ${isContactLoading ? "cursor-wait" : "cursor-pointer"}`}
                      onClick={updateContactProfileInfo}
                      type="button"
                      disabled={isContactLoading}
                    >
                      Reset
                    </button>
                  </>
                ) : null}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ClientContactProfile;
